enum FieldsTableColumnSize {
  FieldName = 40,
  FieldValue = 60,
}

export default FieldsTableColumnSize;
